// Custom middleware configuration

import type { Middleware } from '@reduxjs/toolkit';
import { isDevelopment } from '@/config/env';

// Logger middleware for development
const loggerMiddleware: Middleware = (store) => (next) => (action) => {
  if (isDevelopment()) {
    console.group(`🔄 Action: ${typeof action === 'object' && action !== null && 'type' in action ? action.type : 'unknown'}`);
    console.log('Previous State:', store.getState());
    console.log('Action:', action);
  }

  const result = next(action);

  if (isDevelopment()) {
    console.log('Next State:', store.getState());
    console.groupEnd();
  }

  return result;
};

// Error handling middleware
const errorMiddleware: Middleware = () => (next) => (action) => {
  try {
    return next(action);
  } catch (error) {
    console.error('Redux Error:', error);

    // You could dispatch an error action here
    // store.dispatch(setGlobalError(error.message));

    throw error;
  }
};

// Auth token middleware - automatically adds auth headers to API requests
const authMiddleware: Middleware = () => (next) => (action) => {
  // This middleware can be used to automatically inject auth tokens
  // into API requests or handle auth-related actions

  return next(action);
};

// Combine all custom middleware
export const customMiddleware = [
  ...(isDevelopment() ? [loggerMiddleware] : []),
  errorMiddleware,
  authMiddleware,
];
